import React from 'react';
import Card from 'components/Card';
import Flag from 'components/Flag';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SearchWidgetCard(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    children = _ref.children,
    arrowSlot = _ref.arrowSlot;
  return /*#__PURE__*/_jsxs(Card, {
    p: "m",
    py: "s",
    overflow: "visible",
    position: "relative",
    children: [/*#__PURE__*/_jsxs(Stack, {
      spacing: "xs",
      children: [/*#__PURE__*/_jsx(Flag, {
        token: icon,
        spacing: "xs",
        children: /*#__PURE__*/_jsx(Heading, {
          as: "h2",
          size: "small",
          children: title
        })
      }), children]
    }), arrowSlot]
  });
}